import { render, staticRenderFns } from "./CompanyPatientsView.vue?vue&type=template&id=c6b714dc&scoped=true"
import script from "./CompanyPatientsView.vue?vue&type=script&lang=js"
export * from "./CompanyPatientsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6b714dc",
  null
  
)

export default component.exports